// extracted by mini-css-extract-plugin
module.exports = {"FancyInput":"FancyInput__2lPj2"};